module.exports = __webpack_public_path__ + "media/images/contractor-bg-180720ba18207fabad77d41f59d60a1b.jpg";